module.exports = __webpack_public_path__ + "static/media/logo-blue.e9264678.png";